/* eslint-disable */
import {
  complement,
  identical,
  lensPath,
  pipe,
  prop,
  reduce,
  set,
  unless,
  view
} from 'ramda';

import config from '../../config';

// Persists query key on location change
const persistQuery = key => (prevState, nextState) => {
  const lens = lensPath(['location', 'query', key]);

  const isKeySet = pipe(view(lens), Boolean);
  const isKeyNotSet = complement(isKeySet);
  if (isKeyNotSet(prevState) || isKeySet(nextState)) return nextState;

  const newState = set(lens, view(lens, prevState), nextState);
  return newState;
};

export const persistShowShops = persistQuery('showShops');

// Composes hooks with replacing location on the end
export const composeReplaceHooks = (...fns) => (prevState, nextState, replace) =>
  pipe(
    reduce((acc, fn) => fn(prevState, acc), nextState),
    prop('location'),
    unless(
      identical(nextState.location),
      replace
    ),
  )(fns);

// updates links with a PUBLISH_URL prefix in consolidated mode
export const prependLocationPrefix = (path) => {
  let formattedPath = path;
  if (!formattedPath.startsWith('/')) {
    formattedPath = '/' + formattedPath;
  }

  return `${config.pathPrefix}${formattedPath}`;
};

export const openLocationWithPrefix = (path) => {
  window.location.href = prependLocationPrefix(path);
}



// WEBPACK FOOTER //
// ./src/app/utils/routes.js